import React from "react";
import { useNavigate } from "react-router-dom";
import useLocation from "../hooks/useLocation";

export default function Location() {
  const navigate = useNavigate();
  const { position, error, currentParcel, nearestParcel } = useLocation();

  return (
    <div>
      <div className="page-head my-2 d-flex">
        <h3 className="title">
          <strong>Lokáció</strong>
        </h3>
      </div>

      {!position && !error && <p>Pozíció betöltése...</p>}
      {error && <p style={{ color: "red" }}>Hiba: {error}</p>}

      {position && (
        <div>
          <p>
            <strong>Aktuális koordináta:</strong>{" "}
            {position.lat.toFixed(5)}, {position.lng.toFixed(5)}
          </p>

          {currentParcel ? (
            <p>
              🎯 Jelenleg ezen a parcellán állsz:{" "}
              <strong>{currentParcel.parcel_name}</strong>
            </p>
          ) : nearestParcel ? (
            <p>
              📍 Legközelebbi parcella:{" "}
              <strong>{nearestParcel.parcel_name}</strong> (
              {nearestParcel.dist.toFixed(1)} m)
            </p>
          ) : (
            <p>Nincs elérhető parcella.</p>
          )}
        </div>
      )}
    </div>
  );
}
